export default "<ngx-gallery [options]=\"galleryOptions\" [images]=\"gallery\"></ngx-gallery>"